import middleware from './middleware';
import { i18n } from '@/i18n'
import { computed } from 'vue';
import { useAuthStore } from '@/store/auth';
// ServerLayout should be lazy-loaded to avoid dynamic+static collisions

const requirePageContext = (to, from, next) => {
    if (!useAuthStore().authenticated) return middleware.user(to, from, next)
    if (!useAuthStore().user?.is_page) return next({ name: 'home' })
    return next()
}

export default [
    {
        path: '/'+ window.siteConfig.profilePrefix +':user_name/events/:slug',
        name: 'page_event_detail',
        component: () => import('@/pages/user_pages/UserPageEventDetail.vue'),
        beforeEnter: middleware.all,
        meta: { title: computed(() => i18n.global.t('Eveniment')) }
    },
    {
        path: '/cms',
        name: 'cms_management',
        redirect: { name: 'admin_pages_index' },
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('CMS')) }
    },
    {
        path: '/pages/cms/pages',
        name: 'admin_pages_index',
        component: () => import('@/pages/cms/pages/PagesIndex.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Pagini')) }
    },
    {
        path: '/pages/cms/pages/create',
        name: 'admin_pages_create',
        component: () => import('@/pages/cms/pages/PagesCreate.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Creează pagină')) }
    },
    {
        path: '/pages/cms/pages/:id/edit',
        name: 'admin_pages_edit',
        component: () => import('@/pages/cms/pages/PagesEdit.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Editează pagina')) }
    },
    {
        path: '/pages/cms/posts',
        name: 'admin_posts_index',
        component: () => import('@/pages/cms/pages/PostsIndex.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Posturi')) }
    },
    {
        path: '/pages/cms/posts/create',
        name: 'admin_posts_create',
        component: () => import('@/pages/cms/pages/PostsCreate.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Creează post')) }
    },
    {
        path: '/pages/cms/posts/:id/edit',
        name: 'admin_posts_edit',
        component: () => import('@/pages/cms/pages/PostsEdit.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Editează post')) }
    },
    {
        path: '/pages/cms/media',
        name: 'admin_media_index',
        component: () => import('@/pages/cms/pages/MediaIndex.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Media')) }
    },
    {
        path: '/pages/cms/media/create',
        name: 'admin_media_create',
        component: () => import('@/pages/cms/pages/MediaCreate.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Upload media')) }
    },
    {
        path: '/pages/cms/media/:id/edit',
        name: 'admin_media_edit',
        component: () => import('@/pages/cms/pages/MediaEdit.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Editează media')) }
    },
    {
        path: '/pages/cms/forms',
        name: 'admin_forms_index',
        component: () => import('@/pages/cms/pages/FormsIndex.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Forms')) }
    },
    {
        path: '/pages/cms/forms/create',
        name: 'admin_forms_create',
        component: () => import('@/pages/cms/pages/FormsCreate.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Creează formular')) }
    },
    {
        path: '/pages/cms/forms/:id/edit',
        name: 'admin_forms_edit',
        component: () => import('@/pages/cms/pages/FormsEdit.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Editează formular')) }
    },
    {
        path: '/pages/cms/crm',
        name: 'admin_crm_index',
        component: () => import('@/pages/cms/pages/CrmIndex.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('CRM')) }
    },
    {
        path: '/pages/cms/crm/create',
        name: 'admin_crm_create',
        component: () => import('@/pages/cms/pages/CrmCreate.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Lead nou')) }
    },
    {
        path: '/pages/cms/crm/:id/edit',
        name: 'admin_crm_edit',
        component: () => import('@/pages/cms/pages/CrmEdit.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Editează lead')) }
    },
    {
        path: '/pages/cms/appointments',
        name: 'admin_appointments_index',
        component: () => import('@/pages/cms/pages/AppointmentsIndex.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Programări')) }
    },
    {
        path: '/pages/cms/appointments/create',
        name: 'admin_appointments_create',
        component: () => import('@/pages/cms/pages/AppointmentsCreate.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Programare nouă')) }
    },
    {
        path: '/pages/cms/appointments/:id/edit',
        name: 'admin_appointments_edit',
        component: () => import('@/pages/cms/pages/AppointmentsEdit.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Editează programare')) }
    },
    {
        path: '/pages/cms/documents',
        name: 'admin_documents_index',
        component: () => import('@/pages/cms/pages/DocumentsIndex.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Documente')) }
    },
    {
        path: '/pages/cms/documents/create',
        name: 'admin_documents_create',
        component: () => import('@/pages/cms/pages/DocumentsCreate.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Document nou')) }
    },
    {
        path: '/pages/cms/documents/:id/edit',
        name: 'admin_documents_edit',
        component: () => import('@/pages/cms/pages/DocumentsEdit.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Editează document')) }
    },
    {
        path: '/pages/cms/events',
        name: 'admin_events_index',
        component: () => import('@/pages/cms/pages/EventsIndex.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Evenimente')) }
    },
    {
        path: '/pages/cms/events/create',
        name: 'admin_events_create',
        component: () => import('@/pages/cms/pages/EventsCreate.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Eveniment nou')) }
    },
    {
        path: '/pages/cms/events/:id/edit',
        name: 'admin_events_edit',
        component: () => import('@/pages/cms/pages/EventsEdit.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Editează eveniment')) }
    },
    {
        path: '/pages/cms/reports',
        name: 'admin_reports_index',
        component: () => import('@/pages/cms/pages/ReportsIndex.vue'),
        beforeEnter: requirePageContext,
        meta: { title: computed(() => i18n.global.t('Rapoarte')) }
    },
    {
        path: '/pages/:tab?',
        name: 'user_pages',
        component: () => import('@/pages/ServerLayout.vue'),
        beforeEnter: middleware.user,
        meta: { title: computed(() => i18n.global.t('Pages')) }
    },
    {
        path: '/pages/create',
        name: 'user_pages_create',
        component: () => import('@/pages/user_pages/UserPagesCreate.vue'),
        beforeEnter: middleware.user,
        meta: { title: computed(() => i18n.global.t('Create New Page')) }
    },
    {
        path: '/pages/reports',
        name: 'user_pages_reports',
        component: () => import('@/pages/user_pages/UserPagesReport.vue'),
        beforeEnter: middleware.user,
        meta: { title: computed(() => i18n.global.t('Report')) },
        children: [
            {
                path: '',
                name: 'user_pages_overview',
                props: true,
                component: () => import('@/pages/user_pages/UserPagesReportOverview.vue'),
                beforeEnter: middleware.user,
                meta: { title: computed(() => i18n.global.t('Overview')) },
            },
            {
                path: 'manage_users',
                name: 'user_pages_manage_users',
                props: true,
                component: () => import('@/pages/user_pages/UserPagesManageUsers.vue'),
                beforeEnter: middleware.user,
                meta: { title: computed(() => i18n.global.t('Manage Users')) },
            },
            {
                path: 'notify_settings',
                name: 'user_pages_notify_settings',
                props: true,
                component: () => import('@/pages/user_pages/UserPagesNotifySettings.vue'),
                beforeEnter: middleware.user,
                meta: { title: computed(() => i18n.global.t('Manage Users')) },
            },
            {
                path: 'site',
                name: 'user_pages_site',
                props: true,
                component: () => import('@/pages/user_pages/UserPagesSite.vue'),
                beforeEnter: middleware.user,
                meta: { title: computed(() => i18n.global.t('Website Settings')) },
            },
            {
                path: 'commerce',
                name: 'user_pages_commerce',
                props: true,
                component: () => import('@/pages/user_pages/UserPagesCommerce.vue'),
                beforeEnter: middleware.user,
                meta: { title: computed(() => i18n.global.t('Commerce')) },
            },
            {
                path: 'cms',
                name: 'user_pages_cms',
                props: true,
                component: () => import('@/pages/user_pages/UserPagesCms.vue'),
                beforeEnter: middleware.user,
                meta: { title: computed(() => i18n.global.t('CMS')) },
            }
        ]
    },
    {
        path: '/pages/feature',
        name: 'user_pages_feature',
        component: () => import('@/pages/user_pages/UserPagesFeature.vue'),
        beforeEnter: middleware.user,
        meta: { title: computed(() => i18n.global.t('Feature Page')) }
    }
]
